import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import sleep from 'sleep-promise';
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";

function Form() {
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.pdc_entity_id) {
        hiddenValues.pdc_entity_id = profileFilter.pdc_entity_id
    }

    if (profileFilter.pdc_project_ids) {
        hiddenValues.pdc_project_ids = profileFilter.pdc_project_ids
    }


    const path = '/selectionprocesses/';
    const paths = {
        endpointSave: config.endpoints.backend + 'selectionprocesses/save',
        endpointGetById: config.endpoints.backend + 'selectionprocesses/getById',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Processo Seletivo",
        labelTitleEdit: "Editar Processo Seletivo",
        labelTitleView: 'Visualizar Processo Seletivo'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                !hiddenValues.pdc_entity_id && !hiddenValues.pdc_project_ids ? {
                    name: 'pdc_entity_id',
                    type: 'select',
                    label: 'Entidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllEntities,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    handleChange: async (element, field, values) => {
                        let form = getForm(values);

                        // reset multiinput
                        values.projects = [{ project: '' }]
                        
                        form.fields[0].autoFocus = true;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    }
                } : {},
                {
                    name: 'projects',
                    type: 'multiinput',
                    label: 'Projetos',
                    sortBy: 'index',
                    form: [
                        {
                            name: 'project',
                            type: 'select',
                            label: 'Projeto',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllProjects,
                                label: 'project_name',
                                value: 'id',
                                params: {
                                    filter: {
                                        ...hiddenValues,
                                        pdc_entity_id: hiddenValues.pdc_entity_id || values.pdc_entity_id ? !hiddenValues.pdc_entity_id ? values.pdc_entity_id : hiddenValues.pdc_entity_id : "none"
                                    }
                                }
                            },
                            validations: {
                                required: true
                            }
                        }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'edital_number',
                    type: 'text',
                    label: 'Número do Edital',
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                },
                {
                    name: 'title',
                    type: 'text',
                    label: 'Título',
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                },
                {
                    name: 'description',
                    type: 'textarea',
                    label: 'Descrição',
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    maxLength: '400'
                },
                {
                    name: 'files',
                    type: 'multiUploadFileS3',
                    label: 'Anexos',
                    limitFileSize: 20,
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    uploadFileLimit: 20
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
